import { lazy } from 'react';
import { authRoles } from 'app/auth';

const DashboardPage = lazy(() => import('./DashboardPage'));

const DashboardConfig = {
  settings: {
    layout: {
      config: {
        footer: {
          display: false,
        },
        healtheraHeader: {
          display: true,
        },
      },
    },
  },
  auth: authRoles.pharmacist,
  routes: [
    {
      path: 'service-dashboard',
      element: <DashboardPage />,
    },
  ],
};

export default DashboardConfig;
